var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 31.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 21.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 11.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 11.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 11.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 42.5,
    width: 11,
    height: 11,
    fill: "white",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_133",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_133",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossword);
export default __webpack_public_path__ + "static/media/crossword.1f8510b9bca8f966dec31cf69a9ac6d6.svg";
export { ForwardRef as ReactComponent };